import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/login'
import Index from '@/view/index'
import Home from '@/view/home'
import Contact from '@/view/contact'
import Introduction from '@/view/introduction'
import Product from '@/view/product'
import Product1 from '@/view/product/subMenu/index1'
import Product2 from '@/view/product/subMenu/index2'
import Product3 from '@/view/product/subMenu/index3'
import Product4 from '@/view/product/subMenu/index4'

export default new Router({
  mode: 'hash',
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      component: Home
    },
    //  {
    //   path:'/cmpMainbusiness/index',
    //   component: (resolve) => require(['@/view/cmpMainbusiness/index'],resolve),
    //   children:[
    //     {
    //       path:'/cmpMainbusiness/rpa',
    //       name:'rpa',
    //       component:(resolve) => require(['@/view/cmpMainbusiness/rpa'],resolve),
    //       children:[
    //         {
    //           path:'/cmpMainbusiness/ITcontrol',
    //           name:'ITcontrol',
    //           component:(resolve) => require(['@/view/cmpMainbusiness/ITcontrol'],resolve)
    //         },
    //         {
    //           path:'/cmpMainbusiness/operate',
    //           name:'operate',
    //           component:(resolve) => require(['@/view/cmpMainbusiness/operate'],resolve)
    //         },
    //         {
    //           path:'/cmpMainbusiness/resources',
    //           name:'resources',
    //           component:(resolve) => require(['@/view/cmpMainbusiness/resources'],resolve)
    //         },
    //         {
    //           path:'/cmpMainbusiness/supply',
    //           name:'supply',
    //           component:(resolve) => require(['@/view/cmpMainbusiness/supply'],resolve)
    //         },
    //         {
    //           path:'/cmpMainbusiness/finance',
    //           name:'finance',
    //           component:(resolve) => require(['@/view/cmpMainbusiness/finance'],resolve)
    //         }
    //       ]
    //     },
    //     {
    //       path:'/cmpMainbusiness/scientific',
    //       name:'scientific',
    //       component:(resolve) => require(['@/view/cmpMainbusiness/scientific'],resolve)
    //     }
    //   ]
    //  },
    {
      path: '/solve/index',
      name: 'solve',
      component: (resolve) => require(['@/view/solve/index'], resolve)
    },
    {
      path: '/serve/index',
      name: 'serve',
      component: (resolve) => require(['@/view/serve/index'], resolve)
    },
    {
      path: '/case/index',
      name: 'serve',
      component: (resolve) => require(['@/view/case/index'], resolve)
    },
    {
      path: '/yunNews/index',
      name: 'serve',
      component: (resolve) => require(['@/view/yunNews/index'], resolve)
    },
    {
      path: '/newsOne/index',
      name: 'serve',
      component: (resolve) => require(['@/view/yunNews/newsOne'], resolve)
    },
    {
      path: '/pull/login',
      name: 'login',
      component: (resolve) => require(['@/view/pull/login'], resolve)
    },
    {
      path: '/pull/regiester',
      name: 'regiester',
      component: (resolve) => require(['@/view/pull/regiester'], resolve)
    },
    {
      path: '/gotosigao/index',
      name: 'gotosigao',
      component: (resolve) => require(['@/view/gotosigao/index'], resolve),
      children: [
        {
          path: '/gotosigao/befintroduction',
          name: 'befintroduction',
          component: (resolve) => require(['@/view/gotosigao/befintroduction'], resolve),
        }, {
          path: '/gotosigao/culture',
          name: 'culture',
          component: (resolve) => require(['@/view/gotosigao/culture'], resolve),
        }, {
          path: '/gotosigao/team',
          name: 'team',
          component: (resolve) => require(['@/view/gotosigao/team'], resolve),
        }, {
          path: '/gotosigao/qualification',
          name: 'qualification',
          component: (resolve) => require(['@/view/gotosigao/qualification'], resolve),
        }, {
          path: '/gotosigao/course',
          name: 'course',
          component: (resolve) => require(['@/view/gotosigao/course'], resolve),
        },
      ]
    },
    {
      path: '/news/index',
      nme: 'news',
      component: (resolve) => require(['@/view/news/index'], resolve),
    },
    {
      path: '/news/newsdetails',
      name: 'newsdetails',
      component: (resolve) => require(['@/view/news/newsdetails'], resolve)
    },
    {
      path: '/cusCase/index',
      name: 'cusCase',
      component: (resolve) => require(['@/view/cusCase/index'], resolve),
      children: [
        {
          path: '/cusCase/caselist',
          name: 'caselist',
          component: (resolve) => require(['@/view/cusCase/caselist'], resolve)
        },
        {
          path: '/cusCase/coopCus',
          name: 'coopCus',
          component: (resolve) => require(['@/view/cusCase/coopCus'], resolve)
        }
      ]
    },
    {
      path: '/cusCase/casedetails',
      name: 'casedetails',
      component: (resolve) => require(['@/view/cusCase/casedetails'], resolve)
    },
    {
      path: '/joinus/index',
      name: 'joinus',
      component: (resolve) => require(['@/view/joinus/index'], resolve),
      children: [
        {
          path: '/joinus/connet',
          name: 'connet',
          component: (resolve) => require(['@/view/joinus/connet'], resolve)
        },
        {
          path: '/joinus/advertise',
          name: 'advertise',
          component: (resolve) => require(['@/view/joinus/advertise'], resolve)
        }
      ]
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: Login
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/home/index',
      name: 'Home',
      component: Home
    },
    {
      path: '/contact/index',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/introduction/index',
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/product/index',
      name: 'Product',
      component: Product
    },
    {
      path: '/product/subMenu/index1',
      name: 'Product1',
      component: Product1
    },
    {
      path: '/product/subMenu/index2',
      name: 'Product2',
      component: Product2
    },
    {
      path: '/product/subMenu/index3',
      name: 'Product3',
      component: Product3
    },
    {
      path: '/product/subMenu/index4',
      name: 'Product4',
      component: Product4
    },
  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
Vue.use(Router)
